<template>
  <div class="welcome">
    <div class="headBox">
      <div class="head_title">预约流水(单位: 元)</div>
      <div class="money">
        <span class="card card_device" v-if="statisticsInfo3.breadOrder">
          <div class="card_title">总金额<span>{{statisticsInfo3.breadOrder.amountA0}}</span></div>
          <ul>
            <li>
              昨日:
              <span>{{statisticsInfo3.breadOrder.amountD2}}</span>
            </li>
            <li>
              今日:
              <span>{{statisticsInfo3.breadOrder.amountD1}}</span>
            </li>
          </ul>
        </span>
        <span class="card card_wx" v-if="statisticsInfo3.breadOrder">
          <div class="card_title">微信金额<span>{{statisticsInfo3.breadOrder.amountWA0}}</span></div>
          <ul>
            <li>
              昨日:
              <span>{{statisticsInfo3.breadOrder.amountWD2}}</span>
            </li>
            <li>
              今日:
              <span>{{statisticsInfo3.breadOrder.amountWD1}}</span>
            </li>
          </ul>
        </span>
        <span class="card card_zfb" v-if="statisticsInfo3.breadOrder">
          <div class="card_title">支付宝金额<span>{{statisticsInfo3.breadOrder.amountAA0}}</span></div>
          <ul>
            <li>
              昨日:
              <span>{{statisticsInfo3.breadOrder.amountAD2}}</span>
            </li>
            <li>
              今日:
              <span>{{statisticsInfo3.breadOrder.amountAD1}}</span>
            </li>
          </ul>
        </span>
      </div>
    </div>
    <div class="bodyBox">
      <div class="foot_title">预约订单量</div>
      <table v-if="statisticsInfo2.breadOrder">
        <tr>
          <th>订单数</th>
          <th>预约订单总数</th>
          <th>微信预约订单数</th>
          <th>微信完成订单数</th>
          <th>支付宝预约订单数</th>
          <th>支付宝完成订单数</th>
        </tr>
        <tr>
          <td>总计</td>
          <td>{{statisticsInfo2.breadOrder.countA0}}</td>
          <td>{{statisticsInfo2.breadOrder.countWA0}}</td>
          <td>{{statisticsInfo2.breadOrder.countWUA0}}</td>
          <td>{{statisticsInfo2.breadOrder.countAA0}}</td>
          <td>{{statisticsInfo2.breadOrder.countAUA0}}</td>
        </tr>
        <tr>
          <td>昨日</td>
          <td>{{statisticsInfo2.breadOrder.countD2}}</td>
          <td>{{statisticsInfo2.breadOrder.countWD2}}</td>
          <td>{{statisticsInfo2.breadOrder.countWUD2}}</td>
          <td>{{statisticsInfo2.breadOrder.countAD2}}</td>
          <td>{{statisticsInfo2.breadOrder.countAUD2}}</td>
        </tr>
        <tr>
          <td>今日</td>
          <td>{{statisticsInfo2.breadOrder.countD1}}</td>
          <td>{{statisticsInfo2.breadOrder.countWD1}}</td>
          <td>{{statisticsInfo2.breadOrder.countWUD1}}</td>
          <td>{{statisticsInfo2.breadOrder.countAD1}}</td>
          <td>{{statisticsInfo2.breadOrder.countAUD1}}</td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import { statistics2, statistics3 } from '@/API/welcome'
export default {
  name: 'capital',
  data() {
    return {
      statisticsInfo2: {},
      statisticsInfo3: {}
    }
  },
  mounted() {
    this.getStatistics2()
    this.getStatistics3()
  },
  methods: {
    // 获取数据展示区域数据
    async getStatistics2() {
      const { data: res } = await statistics2()
      if (res.code !== 200) return this.$message.error(res.message)
      this.statisticsInfo2 = res.data
    },
    // 获取数据展示区域数据
    async getStatistics3() {
      const { data: res } = await statistics3()
      if (res.code !== 200) return this.$message.error(res.message)
      this.statisticsInfo3 = res.data
    }
  }
}
</script>

<style lang="less" scoped>
.welcome {
  min-width: 1080px;
  padding: 0 15px;
}
.headBox {
  margin-bottom: 24px;
  .head_title {
    font-size: 20px;
    font-weight: 700;
    line-height: 50px;
    color: #2a3948;
    &::before {
      content: '';
      display: inline-block;
      margin: 0 15px;
      width: 14px;
      height: 14px;
      background-color: #3e79d3;
      transform: rotate(45deg);
    }
  }
  .money {
    display: flex;
    justify-content: space-between;
    .card {
      display: flex;
      flex-direction: column;
      width: 32%;
      height: 138px;
      color: #fff;
      background-size: 100% 100% !important;
      .card_title {
        margin-left: 20px;
        font-size: 20px;
        line-height: 60px;
        span {
          font-size: 36px;
          float: right;
          padding-right: 30px;
        }
      }
      ul {
        flex: 1;
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        font-size: 14px;
        > li > span {
          margin-left: 10px;
          font-size: 20px;
          vertical-align: middle;
        }
      }
    }
    .card_device {
      background: url('../../assets/images/1.png') no-repeat;
    }
    .card_wx {
      background: url('../../assets/images/2.png') no-repeat;
    }
    .card_zfb {
      background: url('../../assets/images/3.png') no-repeat;
    }
  }
}

.bodyBox {
  width: 100%;
  box-shadow: 0px 3px 18px 0px rgba(0, 0, 0, 0.1);
  border-radius: 10px;
  margin-bottom: 24px;
  .foot_title {
    font-size: 20px;
    font-weight: 700;
    line-height: 50px;
    color: #2a3948;
    &::before {
      content: '';
      display: inline-block;
      margin: 0 15px;
      width: 14px;
      height: 14px;
      background-color: #3e79d3;
      transform: rotate(45deg);
    }
    &::after {
      content: '';
      display: block;
      width: 100%;
      height: 5px;
      background-color: #fbf8fb;
    }
  }
  table {
    width: 96%;
    margin: 0 2%;
    font-size: 16px;
    color: #666666;
    border-collapse: collapse;
    tr {
      margin: 0 45px;
      line-height: 50px;
      &:nth-child(1),
      &:nth-child(2),
      &:nth-child(3) {
        border-bottom: 5px solid #fbf8fb;
      }
      td {
        text-align: center;
      }
    }
  }
}

.footBox {
  display: flex;
  justify-content: space-between;
  .card {
    width: 48%;
    box-shadow: 0px 3px 18px 0px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    .head_title {
      font-size: 20px;
      font-weight: 700;
      color: #2a3948;
      line-height: 50px;
      &::before {
        content: '';
        display: inline-block;
        margin: 0 15px;
        width: 14px;
        height: 14px;
        background-color: #3e79d3;
        transform: rotate(45deg);
      }
      &::after {
        content: '';
        display: block;
        height: 5px;
        background-color: #fbf8fb;
      }
    }
    table {
      width: 92%;
      margin: 0 4%;
      color: #666666;
      font-size: 16px;
      border-collapse: collapse;
      tr {
        margin: 0 45px;
        line-height: 50px;
        &:nth-child(1),
        &:nth-child(2),
        &:nth-child(3) {
          border-bottom: 5px solid #fbf8fb;
        }
        td {
          text-align: center;
        }
      }
    }
  }
}
</style>
